import { IconButton } from '@coop/components';
import { SearchIcon } from '@coop/icons';
import type React from 'react';

import CloudinaryImage from '../../../../../common/components/atoms/CloudinaryImage';
import { ConditionalWrapper } from '../../../../../common/components/atoms/ConditionalWrapper';
import { useIsMobile } from '../../../../../common/components/atoms/ResponsiveBreakpoints';
import { missingProductImageUrl } from '../../../../../common/components/molecules/ProductTeaser/ProductTeaser.consts';
import styles from './ProductImage.module.scss';

interface ProductImageProps {
    imageUrl?: string;
    name: string;
    onImageClick?: () => void;
    onZoomClick?: () => void;
}

const ProductImage = (props: React.PropsWithChildren<ProductImageProps>) => {
    const isMobile = useIsMobile();

    return (
        <div className={styles.ProductImageContainer}>
            <ConditionalWrapper
                condition={!isMobile}
                renderWrapper={(children) => (
                    <div onClick={props.onImageClick} className={styles.ProductZoomButton}>
                        {children}
                    </div>
                )}
            >
                <CloudinaryImage
                    url={props.imageUrl}
                    name={props.name}
                    fallbackUrl={missingProductImageUrl}
                    transform="e_sharpen,f_auto,fl_clip,fl_progressive,q_90,c_lpad,g_center,h_500,w_500"
                    retinaTransform="e_sharpen,f_auto,fl_clip,fl_progressive,q_90,c_lpad,g_center,h_1000,w_1000"
                    cssClass={styles.ProductImage}
                />
            </ConditionalWrapper>
            {!isMobile && (
                <div className={styles.ButtonPosition}>
                    <IconButton
                        icon={SearchIcon}
                        label="Förstora produktbild"
                        theme="soft"
                        size={40}
                        onClick={props.onZoomClick}
                        aria-haspopup="dialog"
                    />
                </div>
            )}
        </div>
    );
};

export default ProductImage;
